<template>
  <b-flix-h1>
    <slot />
  </b-flix-h1>
</template>
<script>
export default {
  name: 'mainTitle',
  components: {},
  props: {},
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style lang="sass" scoped>
</style>
